<template>
  <div class="form-group position-relative">
    <label class="form-label"
           :class="formLabelClass"
           v-if="label">{{ label }}</label>
    <div>
      <vue-timepicker v-model="content"
                      :hour-label="$t('hours')"
                      :minute-label="$t('minutes')"
                      :minute-interval="5"
                      :manual-input="allowManual"
                      format="HH:mm"
                      locale="ru"
                      :disabled="readonly"
                      :drop-direction="dropDirection"
                      placeholder="__:__"
                      input-class="display-time skip-error-style"
                      close-on-complete>
      </vue-timepicker>
    </div>
    <ValidationError class="mt-1"
                     v-if="showErrors"
                     :validationId="validationId"/>
  </div>
</template>

<script setup>
import VueTimepicker from 'vue3-timepicker'
import 'vue3-timepicker/dist/VueTimepicker.css'
import ValidationError from "@/components/form/ValidationError"
import { ref, watch } from "vue"

// vue3-timepicker is vue2-timepicker's own Vue 3 port.
// Its input class is vue__time-picker-input instead of display-time: display-time is added through input-class above,
// so the app's styles keep matching

const props = defineProps({
  label: {},
  modelValue: {},
  showErrors: {
    type: Boolean,
    default: false
  },
  readonly: {
    type: Boolean,
    default: false
  },
  allowManual: {
    type: Boolean,
    default: false
  },
  formLabelClass: {
    type: String,
  },
  validationId: {},
  dropDirection: {
    type: String,
    default: 'auto',
  }
})

const emit = defineEmits(['update:modelValue'])

// the value is taken once, as before
const content = ref(props.modelValue)

// the picker may give an object of the parts, it goes out as "HH:mm"
watch(content, (val) => {
  if(typeof val === 'object' && val !== null) {
    let str = val.HH ? val.HH : '00'
    str += ':'
    str += val.mm ? val.mm : '00'
    emit('update:modelValue', str)
  } else {
    emit('update:modelValue', val)
  }
})
</script>

<style scoped lang="scss">
.w-100 {
  :deep(.vue__time-picker) {
    width: 100% !important;
    input.display-time {
      width: 100% !important;
    }
  }
}
</style>
